import {
    LOAD_FAVOURITES,
    ADD_FAVOURITE,
    REMOVE_FAVOURITE,
    SAVE_FAVOURITES
} from '../actions';

import _ from 'lodash';

export default function (state = {
    favouritesList: []
}, action) {

    const newState = _.clone(state);

    switch (action.type) {
        case LOAD_FAVOURITES:
            newState.favouritesList = action.payload;
            return newState;

        case ADD_FAVOURITE:
            let exists = false;
            for (let i = 0; i < newState.favouritesList.length; i++){
                if(newState.favouritesList[i].termName === action.payload.termName){
                    exists = true;
                    return newState;
                }
            }
            // newState.favouritesList = _.concat(newState.favouritesList, action.payload);
            newState.favouritesList.push(action.payload);
            return newState;

        case REMOVE_FAVOURITE:
            _.remove(newState.favouritesList, action.payload);
            return newState;

        case SAVE_FAVOURITES:
            return newState;

        default:
            return state;
    }
}
